import {
  getAuth,
  signInAnonymously,
  signInWithCustomToken,
} from "firebase/auth";
import { functionsV3, httpsCallable } from "./firebaseApp_v3";

// Las funciones de inscripciones validan esta api key contra el secret
// INSCRIPCIONES_API_KEY de Secret Manager.
const API_KEY_INSCRIPCIONES = process.env.REACT_APP_FIREBASE_APIKEY_COTI;
const TEMPLATE_ID_INSCRIPCION = "d-0b28328c53d3436da9438c58c9f9f53d";

export const getStockInfor_V3 = async (codigoMedicamento) => {
  //console.log("nueva funcion stock")
  let respuesta = { obtenido: false };
  try {
    const stockInfor = httpsCallable(functionsV3, "GetStockInfor_General");
    const response = await stockInfor({
      codigoMedicamento,
    });
    // console.log('responde')
    // console.log(response)

    return response.data;
  } catch (error) {
    console.error("error");
    console.error(error);
    respuesta.error = error;
    return respuesta;
  }
};
export const SendGridAdjMulti_V3 = async (data) => {
  let response = { status: "no enviado" };
  try {
    const sendMail = httpsCallable(functionsV3, "EnviaMailAdjunto_vonline");
    const result = await sendMail({ objCorreo: data });
    response = result;
    return response.data;
  } catch (error) {
    console.error("Error inesperado:", error);
    return {
      obtenido: false,
      datos: error,
    };
  }
};

// Entrega el siguiente correlativo de inscripción (CIC26-0001) sin registrar nada.
export const getIdCicletada_V3 = async () => {
  let respuesta = { obtenido: false };
  try {
    const idCicletada = httpsCallable(functionsV3, "GetIdCicletada_v3");
    const response = await idCicletada({ apiKey: API_KEY_INSCRIPCIONES });
    const data = response.data || {};

    // La función responde { exito: false, error } cuando el contador está
    // ocupado: ahí el error es reintentable y no hay id que usar.
    if (!data.exito) {
      respuesta.error = data.error || "No se pudo obtener el id";
      return respuesta;
    }

    respuesta.id = data.idInscripcion;
    respuesta.obtenido = true;

    return respuesta;
  } catch (error) {
    console.error("Error en getIdCicletada_V3");
    console.error(error);
    respuesta.error = error;
    return respuesta;
  }
};

// Registra la inscripción completa (valida ruts y toma el correlativo en una
// sola transacción). Respuesta de la función: { creado, message, id }.
export const registroInscripcionOptimizado_V3 = async (objInscripcion) => {
  try {
    const registraInscrito = httpsCallable(
      functionsV3,
      "RegistrarInscripcionOptimizada_v3"
    );
    const response = await registraInscrito({
      objInscrito: objInscripcion,
      apiKey: API_KEY_INSCRIPCIONES,
    });

    return {
      data: response.data,
    };
  } catch (error) {
    console.log("Error al registrar la inscripción");
    console.log(error);
    return {
      data: {
        creado: false,
        message: "Error al registrar la inscripción",
      },
    };
  }
};

// Sube el QR a Storage y devuelve su URL firmada.
export const UpArchivoStorage_V3 = async (file) => {
  try {
    const upArchivo = httpsCallable(functionsV3, "UpArchivoStorage_v3");
    const response = await upArchivo({
      fecha_inscripcion: file.fecha_inscripcion,
      idInscripcion: file.idInscripcion,
      apiKey: API_KEY_INSCRIPCIONES,
      file: file.base64,
      type: file.type,
      fileName: file.fileName,
    });
    const data = response.data;

    // Con api key inválida la función responde un string, y con los otros
    // fallos un { error }. En ambos casos no viene url.
    if (!data || typeof data === "string" || !data.url) {
      return {
        error: (data && data.error) || data || "No se pudo subir el archivo",
      };
    }

    return {
      actualizado: true,
      data,
    };
  } catch (error) {
    console.log("Error al subir archivo");
    console.log(error);
    return {
      error,
    };
  }
};

// Envía el correo de confirmación con el PDF del QR adjunto.
export const enviaMailInscrito_V3 = async (objEmail) => {
  try {
    const enviaMail = httpsCallable(functionsV3, "EnviaMailInscripcion_v3");
    const response = await enviaMail({
      apiKey: API_KEY_INSCRIPCIONES,
      correo: objEmail.correo_responsable,
      templateID: TEMPLATE_ID_INSCRIPCION,
      nombre_responsable: objEmail.nombre_responsable,
      texto_libre1: objEmail.id_inscripcion,
      texto_libre2: objEmail.imagenInscrustada,
      base64: objEmail.imagenQr,
      fileName: `${objEmail.id_inscripcion}.pdf`,
    });
    const data = response.data;

    return {
      actualizado: Boolean(data) && data.message === "sent",
      data,
    };
  } catch (error) {
    console.log("Error al enviar correo");
    console.log(error);
    return {
      actualizado: false,
      message: error,
    };
  }
};